module.exports = __webpack_public_path__ + "media/images/authorizenet-logo-icon-b6ff3ce4e24d1038d2163d9c3ef4608b.svg";